var $e1819c2136902bf7$exports = {};
$e1819c2136902bf7$exports = {
  "backButton": args => `${args.prevMenuButton}(\u{C73C})\u{B85C} \u{B3CC}\u{C544}\u{AC00}\u{AE30}`,
  "moreActions": `\u{AE30}\u{D0C0} \u{C561}\u{C158}`,
  "unavailable": `\u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C74C}, \u{C790}\u{C138}\u{D788} \u{BCF4}\u{B824}\u{BA74} \u{D3BC}\u{CE58}\u{AE30}`
};
export { $e1819c2136902bf7$exports as default };